import {FlexBox, FlexBoxProps} from '../../index';
import React from 'react';

export const Center: React.FC<FlexBoxProps> = ({children, ...cssProps}) => {
    return (
        <FlexBox alignItems="center" justifyContent="center" {...cssProps}>
            {children}
        </FlexBox>
    );
};
